import { render, staticRenderFns } from "./liveUser.vue?vue&type=template&id=524b7138&"
import script from "./liveUser.vue?vue&type=script&lang=js&"
export * from "./liveUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports